import React from 'react';
import { Banner } from './Banner';

type JobDetailsDeniedBannerProps = {
  isDropRequest?: boolean;
};

export const JobDetailsDeniedBanner = ({ isDropRequest }: JobDetailsDeniedBannerProps) => {
  return (
    <Banner
      bgColor="state.error.backing-1"
      iconColor="state.error.secondary"
      title={isDropRequest ? 'Drop request denied' : 'Conditional release request denied'}
    />
  );
};
